import { BRANDS } from '../../../configuration/constants';
import { processSplash } from '../processSplash';

import bingeHtml from './assets/rubixBinge.html';
import foxtelgncHtml from './assets/rubixFoxtelgnc.html';
import kayoHtml from './assets/rubixKayo.html';

// Old Rubix cube
// import css from './assets/rubix.css';
// import html from './assets/rubix.html';

// New Loading Anination Rubix cube
import newCss from './assets/rubixNew.css';
import newHtml from './assets/rubixNew.html';

const brandInfo = [
    { name: BRANDS.KAYO, html: kayoHtml },
    { name: BRANDS.BINGE, html: bingeHtml },
    { name: BRANDS.FOXTELGNC, html: foxtelgncHtml },
];

export const rubix = processSplash(newHtml, newCss, true, brandInfo);
